import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import error from "../../assets/error.svg";
import leftArrow from "../../assets/icons/left-arrow.svg";
import logoCobee from "../../assets/logo-cobee.svg";
import { Logout } from "../../components/Logout";
import { LinkType, getLink } from "../../links";
import { useMetrics } from "../../metrics";
import { ROUTES } from "../../routes";

const PageFailed = () => {
  const { pageView } = useMetrics();
  const { i18n, t } = useTranslation();
  const { state } = useLocation();
  const { title, subtitle, errorPage, goBackPage } = state || {};

  useEffect(() => {
    if (errorPage) {
      pageView(errorPage);
    }
  }, [errorPage]);

  return (
    <div className="flex flex-col justify-center items-center px-4 py-8 md:py-0">
      <header className="grid grid-cols-12 mt-4 h-16 items-center w-4/5">
        <Link
          className={`col-span-2 justify-end flex gap-3 text-base text-secondary-main`}
          to={goBackPage || ROUTES.HOME}
        >
          <img src={leftArrow} alt="" />
          {t("common.back")}
        </Link>
        <div className="flex justify-center col-start-3 col-span-8">
          <img src={logoCobee} alt="Logo de Cobee" />
        </div>
        <div className="col-span-1 items-start w-max">
          <Logout />
        </div>
      </header>
      <div className="flex flex-col justify-center items-center mt-11 gap-2 max-w-[600px] ">
        <img className="w-20 h-20" src={error} alt="Error" />
        <h1 className="text-gray-900 text-center text-2xl leading-9 font-medium md:mt-7">
          {title ? title : t("page-failed.generic.title")}
        </h1>
        <p className="text-gray-900 text-center text-lg font-medium">
          {subtitle ? (
            subtitle
          ) : (
            <Trans i18nKey={"page-failed.generic.subtitle"}>
              <a
                className="text-secondary-main"
                href={getLink({
                  linkType: LinkType.ContactUs,
                  language: i18n.language,
                })}
                target="_blank"
              ></a>
            </Trans>
          )}
        </p>
      </div>
    </div>
  );
};

export { PageFailed };
